<p-multiSelect
  class="multi-host {{size}}"
  [maxSelectedLabels]="maxSelectedLabels"
  [dataKey]="dataKey"
  [options]="selectItems"
  [appendTo]="appendTo"
  [styleClass]="baseStyle"
  [disabled]="disabled"
  [(ngModel)]="currentValue"
  [selectionLimit]="selectionLimit"
  (onChange)="handleSelection()"
  (onPanelHide)="handleTouched()"
  [defaultLabel]="placeholder"
  [filterPlaceHolder]="filterPlaceHolder"
  [selectedItemsLabel]="selectedItemsLabel"
  [filter]="filter">
</p-multiSelect>
